import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { AuthData } from "./../../model/auth.model";
import { UserData } from "./../../model/user.model";
import { UtilService } from "../util.service";
import { CookieService } from "ngx-cookie-service";
import { MonitorComponent } from "src/app/authenicated modules/modules/monitor/monitor.component";
import CryptoJS from 'crypto-js';
import { AngularFireAuth } from "@angular/fire/compat/auth";
// import  firebase from "firebase";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private token: string | undefined;
  private isAuthenticated = false;
  private authStatusListner = new Subject<boolean>();
  private tokenTimer: any;
  private userData: UserData | undefined;
  private customerId: string | undefined;
  private email: string | undefined;
  private roleSetting: any;
  private authenticateFunctionPath = "https://blp-user-authentication-864798820237.asia-south1.run.app/";


  mainScreenRouting: any = {
    Dashboard: [{ path: "monitor/:code", component: MonitorComponent }],
    Alerts: [
      {
        path: "alert",
        loadChildren: () =>
          import(
            "./../../authenicated modules/modules/alerts/alerts.component"
          ).then((m) => m.AlertsComponent),
      },
    ],
    Configurations: [
      {
        path: "configurations",
        loadChildren: () =>
          import(
            "./../../authenicated modules/modules/configurations/configurations.component"
          ).then((m) => m.ConfigurationsComponent),
      },
    ],
    // "Maintenance":[
    //   {
    //     path: 'maintenance',
    //     loadChildren: () => import('./../../components/page/maintaince/maintaince.module').then(m => m.MaintainceModule)
    //   }
    // ]
  };
  username: any;
  httpHeaders: any

  constructor(
    private http: HttpClient,
    private router: Router,
    private util: UtilService,
    private cookie: CookieService,
    private auth: AngularFireAuth,
  ) {
    this.httpHeaders = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Basic " + btoa("admin@blpadmin.co.in:Sjq73cdd5SAhs"), //VEPT
        //"Authorization": "Basic " + btoa('adminBLP:SanmarBLPadmin') //Conserve
      }),
    };
  }

  getToken() {
    return this.token;
  }

  getAuthStatusListener() {
    return this.authStatusListner.asObservable();
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getUserObject() {
    if (this.userData) {
      return this.userData;
    } else if (this.email && this.customerId) {
      return {
        email: this.email,
        customerId: this.customerId,
      };
    } else {
      return undefined;
    }
  }

  private completeLogin(data: any, result: any, token: string) {
    if (data.remember) {
      this.cookie.set("userid", data.userid, 365);
      this.cookie.set("password", data.password, 365);
      this.cookie.set("vecvloginremember", "true", 365);
    } else {
      this.cookie.delete("userid");
      this.cookie.delete("password");
      this.cookie.set("vecvloginremember", "false", 365);
    }
    const expiresInDuration = 3600;
    this.isAuthenticated = true;
    this.userData = result.details;
    this.roleSetting = result.details ? result.details["roleSetting"] : null;
    this.customerId = result.details ? result.details.customerId : null;
    this.email = result.details ? result.details.email : null;
    this.username = result.details ? result.details.name : null;
    this.authStatusListner.next(true);
    const now = new Date();
    const expirationDate = new Date(
      now.getTime() + expiresInDuration * 1000
    );
    this.saveAuthData(
      token,
      expirationDate,
      this.customerId,
      this.email,
      this.userData ? this.userData.role : '',
      this.roleSetting,
      this.username
    );
    let getSelectedTabs = this.util.getAccessTab();
    if (!getSelectedTabs) {
      this.util.showSnakbarMessage(
        "error",
        "No access to any screen please contact admin",
        "end",
        "top"
      );
      this.util.setLoaderValue(false);
    } else {
      let orionLogin = sessionStorage.getItem('vecvexternalLogin') ? sessionStorage.getItem('vecvexternalLogin') : false;
      if (!orionLogin) {
        this.util.showSnakbarMessage(
          "success",
          "Successfully Logged in",
          "end",
          "top"
        );
      }
      this.router.navigate(["/home/" + getSelectedTabs[0].href]).then(() => {
        this.util.setLoaderValue(false);
      });
    }
  }

  login(data: any) {
    const authData: AuthData = {
      email: data.userid,
      password: data.password,
      productId: environment.productId
    };
    let body = {
      encrypted: '',
    };
    body['encrypted'] = this.util.encrypt(authData);
    if (environment.api_endpoint === "onpremise") {
    } else if (environment.api_endpoint === "firebase") {
      this.http
        .post<{ message: UserData }>(
          this.authenticateFunctionPath + "signIn",
          body, this.httpHeaders
        )
        .toPromise()
        .then((response) => {
          let result = JSON.parse(this.util.decrypt(response['encrypted']));
          if (result.status == "success" && result.message) {
            const token = result.message;
            this.token = token;
            if (token) {
              let encrypted = this.encrypt(
                { email: data.userid }
              );
              this.getfirebaseToken({ encrypted: encrypted })
                .subscribe(
                  (res: any) => {
                    try {
                      let decrypt = this.decrypt(res['encrypted']);
                      decrypt = JSON.parse(decrypt);
                      this.auth.setPersistence('local')
                        .then(() => {
                          this.auth
                            .signInWithCustomToken(decrypt.token)
                            .then((user) => {
                              this.completeLogin(data, result, token);
                            })
                            .catch((err) => {
                              console.warn("Custom Token Authentication warning:", err);
                              this.completeLogin(data, result, token);
                            });
                        })
                        .catch((err) => {
                          console.warn("Auth persistence warning:", err);
                          this.completeLogin(data, result, token);
                        });
                    } catch (e) {
                      console.warn("Token decrypt warning:", e);
                      this.completeLogin(data, result, token);
                    }
                  },
                  (err) => {
                    console.warn("getfirebaseToken warning:", err);
                    this.completeLogin(data, result, token);
                  }
                );
            } else {
              this.util.setLoaderValue(false);
              this.util.showSnakbarMessage(
                "error",
                "Token Missing",
                "end",
                "top"
              );
              this.authStatusListner.next(false);
            }
          } else {
            this.util.showSnakbarMessage("error", result.message || "Login failed, password or mail id incorrect", "end", "top");
            this.authStatusListner.next(false);
            this.util.setLoaderValue(false);
          }
        })
        .catch((err) => {
          this.util.showSnakbarMessage(
            "error",
            "Please Contact Admin!!!",
            "end",
            "top"
          );
          this.util.setLoaderValue(false);
          this.authStatusListner.next(false);
        });
    }
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return;
    }
    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if (expiresIn > 0) {
      this.token = authInformation.token;
      this.isAuthenticated = true;
      this.email = authInformation.email;
      this.customerId = authInformation.customerId;
      //this.setAuthTimer(expiresIn / 1000);
      this.authStatusListner.next(true);
    }
  }

  logout() {
    this.token = undefined;
    this.isAuthenticated = false;
    this.userData = undefined;
    this.email = undefined;
    this.customerId = undefined;
    this.authStatusListner.next(false);
    this.router.navigate(["/"]);
    this.clearAuthData();
    clearTimeout(this.tokenTimer);
    window.location.reload();
  }

  private setAuthTimer(duration: number) {
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, duration * 1000);
  }

  private saveAuthData(
    token: string,
    expirationDate: Date,
    customerId: string,
    email: string,
    role: string,
    roleSetting: any,
    username: string
  ) {
    localStorage.setItem("token", token);
    localStorage.setItem("email", email);
    localStorage.setItem("customerId", customerId);
    localStorage.setItem("username", username);
    localStorage.setItem("expiration", expirationDate.toISOString());
    localStorage.setItem("role", role);
    if (roleSetting) {
      localStorage.setItem("roleSetting", JSON.stringify(roleSetting));
    }
  }

  private clearAuthData() {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("customerId");
    localStorage.removeItem("expiration");
    localStorage.removeItem("role");
    localStorage.removeItem("roleSetting");
    localStorage.removeItem("globalAssetcode");
    localStorage.removeItem("globalSection");
  }

  private getAuthData() {
    const token = localStorage.getItem("token");
    const expirationDate = localStorage.getItem("expiration");
    const email = localStorage.getItem("email");
    const customerId = localStorage.getItem("customerId");
    let roleSetting = localStorage.getItem("roleSetting");
    if (roleSetting && roleSetting != "undefined") {
      roleSetting = JSON.parse(roleSetting);
    } else {
      roleSetting = null;
    }
    if (!token || !expirationDate || !email || !customerId) {
      return;
    }
    let authData: any = {
      token,
      email,
      customerId,
      expirationDate: new Date(expirationDate),
    };
    // if (roleSetting) {
    //   authData["roleSetting"] = roleSetting;
    //   this.setRoleBasedScreen(roleSetting);
    // }
    return authData;
  }

  setRoleBasedScreen(roleSetting) {
    if (roleSetting.screens && roleSetting.screens.length > 0) {
      this.router.config[3].children = [];
      let routingChildren = this.router.config[3].children;
      let checkDashboard = roleSetting.screens.filter((screenData) => {
        return screenData.text == "Dashboard";
      });
      if (checkDashboard.length > 0) {
        routingChildren.push({
          path: "",
          component: this.mainScreenRouting["Dashboard"][0].component,
        });
      } else {
        routingChildren.push({
          path: "",
          loadChildren:
            this.mainScreenRouting[roleSetting.screens[0].text][0].loadChildren,
        });
      }
      roleSetting.screens.forEach((screenData) => {
        if (screenData.text && this.mainScreenRouting[screenData.text]) {
          this.mainScreenRouting[screenData.text].forEach((route) => {
            routingChildren.push(route);
          });
        }
      });
    }
  }
  encrypt(value: any) {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      environment.firebasetokenKey,
    ).toString();
    return encrypted;
  }
  decrypt(text: any) {
    const decrypted = CryptoJS.AES.decrypt(text, environment.firebasetokenKey);
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  }
  getfirebaseToken(json?: any) {
    let header = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    }
    return this.http.post(
      environment.firebasetokenApi,
      json,
      header,
    );
  }
}
